/**
 * A class that handles the sticky header behavior based on scroll direction.
 */
class StickyHeader {

	lastScrollTop = 0;

	stickyHeader = null;

	/**
	 * Initializes the StickyHeader with the provided header element.
	 *
	 * @param {HTMLElement} header - The header element to be made sticky.
	 */
	constructor( header ) {

		this.stickyHeader = header;

		if ( this.stickyHeader ) {

			this.scrollFunc();
			window.addEventListener( 'scroll', () => this.scrollFunc() );

		}

	}

	/**
	 * Determines the scroll direction.
	 *
	 * @return {number} - Returns 0 if scrolling down, 1 if scrolling up.
	 */
	scrollDirection() {

		const st = window.pageYOffset || document.documentElement.scrollTop;
		const direction = ( st > this.lastScrollTop ) ? 0 : 1;
		this.lastScrollTop = st <= 0 ? 0 : st;
		return direction;

	}

	/**
	 * Handles the scroll functionality by determining direction and applying the appropriate class to the header.
	 */
	scrollFunc() {

		if ( this.stickyHeader ) {

			const direction = this.scrollDirection();
			this.toggleHeaderVisibility( direction );

		}

	}

	/**
	 * Adds or removes the 'active' class on the header based on scroll position and direction.
	 *
	 * @param {number} direction - The scroll direction (0 for down, 1 for up).
	 */
	toggleHeaderVisibility( direction ) {

		const st = window.pageYOffset || document.documentElement.scrollTop;

		// Check if the body has the 'header-open-component' class.
		if ( document.body.classList.contains( 'header-open-component' ) ) {

			document.body.classList.remove( 'header-is-visible' );
			document.body.classList.remove( 'header-is-fixed' );
			return;

		}


		// When scrolling down and below 150px, hide the header.
		if ( direction === 0 && st > 150 ) {

			document.body.classList.add( 'header-is-fixed' );
			document.body.classList.remove( 'header-is-visible' );

		}

		// When scrolling up and below 150px, show the header.
		if ( direction === 1 && st > 150 ) {

			document.body.classList.remove( 'header-is-fixed' );
			document.body.classList.add( 'header-is-visible' );

		}

		// If scroll position is above 150px, remove both classes.
		if ( st <= 150 ) {

			document.body.classList.remove( 'header-is-fixed' );
			document.body.classList.remove( 'header-is-visible' );

		}

	}

	/**
	 * Clones the header element and returns the cloned node.
	 *
	 * @param {HTMLElement} header - The original header element.
	 * @return {HTMLElement} - The cloned header element.
	 */
	cloneHeaderElement( header ) {

		if ( header ) {

			const clone = header.cloneNode( true );
			header.parentNode.insertBefore( clone, header.nextSibling );
			return clone;

		}
		return null;

	}

}

export default StickyHeader;
